import { render, staticRenderFns } from "./line-item.vue?vue&type=template&id=3df4b384&"
import script from "./line-item.vue?vue&type=script&lang=js&"
export * from "./line-item.vue?vue&type=script&lang=js&"
import style0 from "./line-item.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df4b384')) {
      api.createRecord('3df4b384', component.options)
    } else {
      api.reload('3df4b384', component.options)
    }
    module.hot.accept("./line-item.vue?vue&type=template&id=3df4b384&", function () {
      api.rerender('3df4b384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resumo/line-item.vue"
export default component.exports